//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum VerificationStatus {
    Unknown = 0,
    Error = 1,
    Passed = 2,
    Failed = 3,
    Paused = 4,
    Pending = 5,
    Attention = 6,
    Skipped = 7,
}
